import React from 'react'

import { Text } from 'src/components/atoms'

import { WarpBarLineChart, WarpSimpleLine } from './styles'
import { ProgressColors } from '../section-header/styles'

interface LineProps {
  color: string
  percent: number
  title: string
  total: number
}

interface Props {
  detractorPercent: number
  detractorTotal: number
  neutralPercent: number
  neutralTotal: number
  promoterPercent: number
  promoterTotal: number
}

function Line({ title, color, total, percent }: LineProps) {
  return (
    <div>
      <div>
        <Text text={title} />
        <span>{`${percent}% / ${total}`}</span>
      </div>
      <div>
        <WarpSimpleLine color={color} width={percent} />
      </div>
    </div>
  )
}
function BarLineChart({
  detractorPercent,
  detractorTotal,
  neutralPercent,
  neutralTotal,
  promoterPercent,
  promoterTotal
}: Props) {
  //template
  return (
    <WarpBarLineChart>
      <Line
        color={ProgressColors.HIGH}
        percent={promoterPercent}
        title="common.nps.promoter"
        total={promoterTotal}
      />
      <Line
        color={ProgressColors.MEDIUM}
        percent={neutralPercent}
        title="common.nps.passive"
        total={neutralTotal}
      />
      <Line
        color={ProgressColors.LOW}
        percent={detractorPercent}
        title="common.nps.detractor"
        total={detractorTotal}
      />
    </WarpBarLineChart>
  )
}

export default BarLineChart
